<!--
    @修改人：黎柏祺
    @修改时间：2018-12-17
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @修改人：黎柏祺
    @修改时间：2018-04-26
    @修改描述：新增指标采集配置栏
    @版本:v1.0.16
    --------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 日志组件管理页
-->
<template>
  <div class="logComponentManage__content">
    <div class="logComponentManage__site mb-base">
      <span class="logComponentManage__siteName">{{ $t('logComponentManage.site') }}</span>
      <g-select class="logComponentManage__siteSelect"
        :list="siteList"
        v-model="siteCode"></g-select>
    </div>
    <el-tabs type="border-card"
      v-model="tabName">
      <el-tab-pane :label="$t('logComponentManage.appServiceConfig')"
        :name="$t('logComponentManage.appServiceConfig')">
        <app-service-config :site-code="siteCode"></app-service-config>
      </el-tab-pane>
      <el-tab-pane :label="$t('logComponentManage.topicConfig')"
        :name="$t('logComponentManage.topicConfig')">
        <topic-config :site-code="siteCode"></topic-config>
      </el-tab-pane>
      <el-tab-pane :label="$t('logComponentManage.appLogPathConfig')"
        :name="$t('logComponentManage.appLogPathConfig')">
        <log-path-config :site-code="siteCode"></log-path-config>
      </el-tab-pane>
      <el-tab-pane :label="$t('logComponentManage.appLogRouteConfig')"
        :name="$t('logComponentManage.appLogRouteConfig')">
        <log-route-config :site-code="siteCode"></log-route-config>
      </el-tab-pane>
      <el-tab-pane :label="$t('logComponentManage.appLogFieldRouteConfig')"
        :name="$t('logComponentManage.appLogFieldRouteConfig')">
        <log-field-route-config :site-code="siteCode"></log-field-route-config>
      </el-tab-pane>
      <el-tab-pane :label="$t('logComponentManage.kpiInterval')"
        :name="$t('logComponentManage.kpiInterval')">
        <kpi-interval :site-code="siteCode"></kpi-interval>
      </el-tab-pane>
      <el-tab-pane :label="$t('logComponentManage.staticConfig')"
        :name="$t('logComponentManage.staticConfig')">
        <static-config :site-code="siteCode"></static-config>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import appServiceConfig from "./appServiceConfig.vue";
import topicConfig from "./topicConfig.vue";
import logPathConfig from "./appLogPathConfig.vue";
import logRouteConfig from "./appLogRouteConfig.vue";
import logFieldRouteConfig from "./appLogFieldRouteConfig.vue";
import kpiInterval from "./kpiInterval.vue";
import staticConfig from "./staticConfig.vue";
import SiteListBiz from "@/logic/cmdb/cmdbBiz";

export default {
  data() {
    const that = this;
    return {
      tabName: that.$t("logComponentManage.appServiceConfig"),
      siteName: "",
      siteList: {},
      siteCode: ""
    };
  },
  components: {
    appServiceConfig,
    topicConfig,
    logPathConfig,
    logRouteConfig,
    logFieldRouteConfig,
    kpiInterval,
    staticConfig
  },
  methods: {
    getSiteList() {
      SiteListBiz.siteList({ perPageCount: 500 }).then(data => {
        let list = {};
        data.dataList.map(item => {
          list[item.siteCode] = item.name;
        });
        this.siteList = list;
        this.siteCode = Object.keys(list)[0];
      });
    }
  },
  mounted() {
    this.getSiteList();
  },
  watch: {
    $route(nVal, oVal) {
      if (
        nVal.name === "logComponentManage" &&
        oVal.name === "alarmTrend" &&
        Object.keys(nVal.query).length !== 0
      ) {
        this.siteName = this.siteList[this.$route.query.siteCode];
      }
    }
  }
};
</script>
<style scoped>
.logComponentManage__site {
  font-size: 16px;
  font-weight: 600;
}
.logComponentManage__site .logComponentManage__siteName {
  font-weight: 700;
  font-size: 16px;
  padding: 0 10px;
}
.logComponentManage__site .logComponentManage__siteSelect {
  width: 200px;
}
</style>
